import { useDebouncedCallback } from "use-debounce";

export function useDebounceFunction(func: () => any, debounceMs = 1500) {
  const debounced = useDebouncedCallback(func, debounceMs);
  return debounced;
}
